let cryptoJS = require('crypto-js');
let moment = require('moment')
let md5 = require('md5-node')
import rsa from '../utils/rsa'

class CryptoAES {
    constructor(prefix = "qsx", domain = "qushixi.cn") {
        this.prefix = prefix;
        this.domain = domain;
    }

    // 生成密钥
    generateKey() {
        //【安全加固 2026-09-04】删除硬编码密钥字面量（'qushixi2022'即服务端jwtkey，已随公开前端bundle泄露）。
        //qsx前缀的加解密实际走 rsa.encrypt / aes.js，本分支为死代码，直接收敛到通用路径
        return `${this.prefix}.${this.domain}`;
    }

    // 加密
    encrypt(word) {
        if (this.prefix === 'qsx') {
            return rsa.encrypt(word)
        }
        let keyStr = this.generateKey();
        let encJson = cryptoJS.AES.encrypt(word, keyStr).toString();
        // 对加密数据进行base64处理
        let encData = cryptoJS.enc.Base64.stringify(cryptoJS.enc.Utf8.parse(encJson));
        return encData;
    }

    // 解密
    decrypt(word) {
        let keyStr = this.generateKey();
        let decData = cryptoJS.enc.Base64.parse(word).toString(cryptoJS.enc.Utf8);
        // 解密数据
        let decJson = cryptoJS.AES.decrypt(decData, keyStr).toString(cryptoJS.enc.Utf8);
        return decJson;
    }
}

export default CryptoAES;